import { Typography } from 'antd';
import React, { useContext } from 'react';
import { CartStateContext } from '~/App/Layout/providers/CartProvider';
import i18n from '~/i18n';
import CartItemRow from './CartItemRow';
import './style.css';
import { useMenuItemById } from '~/App/hooks/useMenu';

const ListItem = ({ saved }: { saved: boolean }) => {
  const menuItemById = useMenuItemById();
  const items = useContext(CartStateContext);

  if (!menuItemById) return null;

  return (
    <div className="cart-list-container">
      {!items || !items.length ? (
        <Typography.Text>{i18n.t('cart_no_items')}</Typography.Text>
      ) : null}
      {items.map((cartItem, index) => {
        const menuItem = menuItemById[cartItem.menuId];
        return (
          <CartItemRow
            key={`${cartItem.menuId}-${index}`}
            index={index}
            cartItem={cartItem}
            menuItem={menuItem}
            disabled={saved}
          />
        );
      })}
    </div>
  );
};

export default ListItem;
